export default {
      id: "check-in-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#check-in",
      toString: function () {
        return this.url;
      }
    }